import withStyles from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/core/styles/createStyles';

import {CommonButton} from './CommonButton.js';

import CommonTheme from '../../../Theme.js';

/** ポジティブボタンで使用するパレット */
const palette = CommonTheme.palette.primary;

// ポジティブボタンスタイル
const styles = (theme) => createStyles({
  root: {
    color: palette.contrastText,
    background: [
      '-webkit-linear-gradient(top, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
      'linear-gradient(to bottom, ' + palette.light + ' 0%, ' + palette.main + ' 100%)',
    ],
    borderColor: palette.dark,
  },
});

/** ポジティブボタンスタイル */
export const PositiveButton = withStyles(styles)(CommonButton);
export default PositiveButton;
